import { useRecoilState } from "recoil";
import { currentOpenOrders } from "../atoms/orders.Atoms";

export function useOrdersData() {
  const [currentOpenOrdersNow, setCurrentOpenOrders] = useRecoilState(currentOpenOrders);
  return [currentOpenOrdersNow, setCurrentOpenOrders] as const;
}